import React from "react";
import PatientListItem from "./PatientListItem";
import PatientListWrapper from "./PatientList.style";

const PatientsList = (props) => {
  const {
    onFilterPatientsChanged,
    ordersIds,
    events,
    patientsPallette,
    showApproved,
    modal,
    order_time_extractions,
    filteredOrders,
  } = props;
  const renderPatients = () => {
    return ordersIds
      ? ordersIds.map((orderId, i) => (
          <PatientListItem
            patientsPallette={patientsPallette}
            onFilterPatientsChanged={onFilterPatientsChanged}
            orderId={orderId}
            key={i}
            events={events}
            showApproved={showApproved}
            order_time_extractions={order_time_extractions || {}}
            filteredOrders={filteredOrders}
          />
        ))
      : [];
  };
  return (
    <PatientListWrapper modal={modal}>{renderPatients()}</PatientListWrapper>
  );
};

export default PatientsList;
